/**
 * Types and interfaces for ID array shrinking.
 */

export enum ShrinkType {
    /** No shrinking - store original array */
    None = "none",
    /** Bitmap shrinking - 1 bit per potential ID in range */
    Bitmap = "bitmap",
    /** Bitmap with Run-Length Encoding */
    BitmapRLE = "bitmapRLE",
    /** Multiple smaller bitmaps with offsets - handles large gaps efficiently */
    ChunkedBitmap = "chunkedBitmap",
}

export interface ShrunkIdArray {
    /** The shrink method used */
    type: ShrinkType;
    /** The shrunk data - either original number[], bitmap Uint8Array, or RLE Uint8Array */
    data: number[] | Uint8Array;
    /** Minimum ID value (offset for bitmap modes) */
    minId?: number;
    /** Original array length for validation */
    length: number;
}

/**
 * Strategy interface for shrinking/expanding ID arrays.
 * Each strategy handles a specific compression approach.
 */
export interface ShrinkStrategy {
    /** Shrink an array of IDs */
    shrink: (ids: number[]) => ShrunkIdArray;
    /** Expand shrunk data back to ID array */
    expand: (shrunk: ShrunkIdArray) => number[];
    /** Estimate the size in bytes for auto-detection */
    estimateSize: (ids: number[], minId: number, maxId: number) => number;
}
